import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BellStateFalseNotiFalseIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BellStateFalseNotiFalseIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M18.8684 18.7764H5.13166C4.41642 18.7764 3.74795 18.457 3.29727 17.8994C2.84708 17.3428 2.67363 16.6211 2.82175 15.9199L4.46905 8.11914C5.21742 4.57422 8.38485 2.00195 12 2.00195C15.6152 2.00195 18.7826 4.57422 19.531 8.11914L21.1783 15.9199C21.3264 16.6211 21.153 17.3428 20.7028 17.8994C20.2521 18.457 19.5836 18.7764 18.8684 18.7764ZM12 3.50195C9.08741 3.50195 6.53632 5.57422 5.93363 8.42968L4.28633 16.2305C4.23176 16.4873 4.29559 16.7519 4.46027 16.9551C4.62496 17.1592 4.87002 17.2764 5.13166 17.2764H18.8684C19.13 17.2764 19.3751 17.1592 19.5398 16.9551C19.7044 16.752 19.7683 16.4873 19.7137 16.2305L18.0664 8.42968C17.4637 5.57421 14.9126 3.50195 12 3.50195Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.8397 21.9971C9.6828 21.9971 7.92783 20.2383 7.92783 18.0762C7.92783 17.6621 8.26304 17.3262 8.6762 17.3262H15.0033C15.4164 17.3262 15.7516 17.6621 15.7516 18.0762C15.7516 20.2383 13.9967 21.9971 11.8397 21.9971ZM9.54297 18.8262C9.85869 19.7949 10.7693 20.4971 11.8397 20.4971C12.9102 20.4971 13.8208 19.7949 14.1365 18.8262H9.54297Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BellStateFalseNotiFalseIcon;
